export default __webpack_public_path__ + "d3baaae8cf85edf162f086a01842201d.svg";